import InformationRow, { InformationRowLayout } from './InformationRow'

export { InformationRowLayout };
export default InformationRow
